import MyWorkComponent from '../MyWorkComponent.vue'
import HomeComponent from '../HomeComponent.vue'
import CalendarView from '../CalendarView.vue'

export default [
    {
        path: '/dashboard',
        name: 'Dashboard',
        meta: { layout: 'default' },
        component: MyWorkComponent,
    },
    {
        path: '/home',
        name: 'Home',
        meta: { layout: 'default' },
        component: HomeComponent,
    },
    {
        path: '/calendar',
        name: 'Calendar',
        meta: { layout: 'default' },
        component: CalendarView,
    },
]
